import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, forkJoin, Observable, Subject } from 'rxjs';
import { PRODUCT_IMAGES } from 'src/app/helpers/google-storage.helper';
import { ORDER_CATEGORY } from 'src/app/helpers/order-categories.helper';
import { CartItems } from 'src/app/models/cart-items.model';
import { CompanyAccessories } from 'src/app/models/company-accessories.model';
import { ProductDataSubject } from 'src/app/models/product-data-subject.model';
import { CartItemsRequest } from 'src/app/models/requests/cart-items-request.model';
import { CompanyAccessoriesVM } from 'src/app/models/view-models/company-accessories-vm.model';
import { CartManagerService } from 'src/app/services/local/cart-manager.service';
import { CompanyComputerAccessoriesService } from 'src/app/services/repositories/company-computer-glasses-accessories.service';
import { CompanyDressGlassesAccessoriesService } from 'src/app/services/repositories/company-dress-glasses-accessories.service';
import { CompanyGlassesAccessoriesService } from 'src/app/services/repositories/company-glasses-accessories.service';
import { CompanyRespiratorInsertAccessoriesService } from 'src/app/services/repositories/company-respirator-accessories.service';

@Component({
    selector: 'app-lens-accessories',
    templateUrl: './lens-accessories.component.html',
    styleUrls: ['./lens-accessories.component.scss'],
    standalone: false
})
export class LensAccessoriesComponent implements OnInit {
  toggleClass: boolean = true;
  imgSrc: string = PRODUCT_IMAGES.glassesAccessories;
  orderCategory: string = ORDER_CATEGORY.glasses;
  selectedAccessories: CompanyAccessoriesVM[] = [];
  accessoriesVM: CompanyAccessoriesVM[] = [];
  tempCartEventsSubject: Subject<ProductDataSubject> = new BehaviorSubject<ProductDataSubject>({status: 'accessory-stage'});

  constructor(private _cartManagerService: CartManagerService,
              private _companyComputerGlassesAccessories: CompanyComputerAccessoriesService,
              private _companyDressGlassesAccessories: CompanyDressGlassesAccessoriesService,
              private _companyGlassesAccessories: CompanyGlassesAccessoriesService,
              private _companyRespiratorAccessories: CompanyRespiratorInsertAccessoriesService,
              private _router: Router) { }

  ngOnInit(): void {
    this.getAllAccessories();
  }

  getAllAccessories() {
    const newCartItem = this._cartManagerService.getNewCartItemRef();
    let accessoriesObservable: any;
    if (newCartItem) {
      this.orderCategory = newCartItem.itemCategory;
      switch (newCartItem.itemCategory) {
        case ORDER_CATEGORY.glasses:
          accessoriesObservable = this._companyGlassesAccessories.getAccessories();
          break;
        case ORDER_CATEGORY.computerGlasses:
          accessoriesObservable = this._companyComputerGlassesAccessories.getAccessories();
          break;
        case ORDER_CATEGORY.dressGlasses:
          accessoriesObservable = this._companyDressGlassesAccessories.getAccessories();
          break;
        case ORDER_CATEGORY.respiratorInserts:
          this.imgSrc = PRODUCT_IMAGES.respiratorAccessories;
          accessoriesObservable = this._companyRespiratorAccessories.getAccessories();
          break;
        default:
          this.redirectToDashboard();
      }
     this.populateAccessories(accessoriesObservable);
    }
    else {
      this.redirectToDashboard();
    }
  }

  populateAccessories(accessoriesObservable: any) {
     accessoriesObservable.subscribe((data: CompanyAccessories[]) => {
      if (data) {
        Object.assign(this.accessoriesVM, data);
      }
    }, (error: any) => {
      console.log(error);
    });
  }

  redirectToDashboard() {
    this._router.navigate(['/dashboard']);
  }

  saveAccessorySelection() {
    if (this.selectedAccessories) {
      let accessoryCartItems: CartItemsRequest[] = [];
      this.selectedAccessories.forEach(accessory => {
        const accessoryCartItem : CartItemsRequest = {
          itemCategory: this.orderCategory,
          itemDescription: accessory.accessoryName,
          itemImageName: accessory.accessoryImage,
          itemDetails: [{
                          id: accessory.referenceId,
                          itemType: 'accessory',
                          itemDescription: accessory.accessoryName
                        }]
        };
        accessoryCartItems.push(accessoryCartItem);
      });
      this._cartManagerService.saveTempAccessoryCartItems(accessoryCartItems);
      this.emitChangeToProductData();
    }
  }

  emitChangeToProductData() {
    let pds: ProductDataSubject = { status:'accessory-stage' }
    this.tempCartEventsSubject.next(pds);
  }

  addToCart() {
    const tempAccessoryCartItems = this._cartManagerService.getTempAccessoryCartItems();
    if (tempAccessoryCartItems) {
      if (tempAccessoryCartItems.length > 0) {
        let addAccessoriesObservables : Observable<CartItems>[] = [];
        for (const accessoryItem of tempAccessoryCartItems) {
          addAccessoriesObservables.push(this._cartManagerService.addCartItem(accessoryItem));
        };
        forkJoin(addAccessoriesObservables)
        .subscribe(data => {
          this.navigateToCart();
        },
        (error: any) => {
          console.log(error);
        });
      }
      else {
        this.navigateToCart();
      }
    }
    else {
      this.navigateToCart();
    }
  }

  toggleCheckbox(index: number, event: any) {
    event.stopPropagation();
    event.preventDefault();
    this.accessoriesVM[index].isSelected = !this.accessoriesVM[index].isSelected;
    if (this.accessoriesVM[index].isSelected) {
      this.selectedAccessories.push(this.accessoriesVM[index]);
    }
    else {
      const selectedItem = this.accessoriesVM[index];
      const selectedIndex = this.selectedAccessories.findIndex(a => a.referenceId == selectedItem.referenceId);
      this.selectedAccessories.splice(selectedIndex, 1);
    }
    this.saveAccessorySelection();
  }

  checkBoxClick(index: number, event: any) {
    event.stopPropagation();
    if (event.target.checked) {
      this.accessoriesVM[index].isSelected = true;
      this.selectedAccessories.push(this.accessoriesVM[index]);
    }
    else {
      this.accessoriesVM[index].isSelected = false;
      const selectedItem = this.accessoriesVM[index];
      const selectedIndex = this.selectedAccessories.findIndex(a => a.referenceId == selectedItem.referenceId);
      this.selectedAccessories.splice(selectedIndex, 1);
    }
    this.saveAccessorySelection();
  }

  navigateToCart() {
    this._router.navigate(['cart']);
  }

}
